import { DatePipe } from '@angular/common';
import range from 'lodash-es/range';

export function getMonths(locale: string) {
    const datePipe = getDatePipe(locale);
    return range(12).map(month => {
        return {
            value: month + 1,
            label: datePipe.transform(new Date(0, month), 'MMMM')
        };
    });
}

const pipeMap = new Map<string, DatePipe>();

function getDatePipe(locale: string): DatePipe {
    if (!pipeMap.has(locale)) {
        pipeMap.set(locale, new DatePipe(locale));
    }
    return pipeMap.get(locale)!;
}
